export default {
  init() {
	// js to fire on Single posts

	jQuery(document).ready(function(){

	var sideHeight = jQuery('.entry-content').height();
	jQuery('#sidebar').css('height', sideHeight + 'px');

	});

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js